/** @format */

import React, { useState } from "react";
import { Button, Modal, Alert, Input, message, Spin } from "antd";
import VoiceGainAuthSvcApi from "../../../../../apis/VoiceGainAuthSvcApi";
import { DeleteOutlined } from "@ant-design/icons";

interface IDeleteUserModal {
	email: string;
	userId: string;
	fetchAndSetUsers: () => void;
}

const DeleteUserModal: React.FC<IDeleteUserModal> = ({
	email,
	userId,
	fetchAndSetUsers,
}) => {
	const [isDeleteModalVisible, setIsDeleteModalVisible] =
		useState<boolean>(false);
	const [deleteConfirmationInput, setDeleteConfirmationInput] =
		useState<string>("");
	const [userSelectedForDeletion, setUserSelectedForDeletion] =
		useState<string>(email);
	const [disableDeleteBtn, setDisableDeleteBtn] = useState<boolean>(true);
	const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);

	const deleteUser = async (userId: string) => {
		try {
			setIsDeleteLoading(true);
			let deleteUserResponse = await VoiceGainAuthSvcApi.deleteUser(userId);

			if (deleteUserResponse.ok) {
				message.success("Successfully deleted user.");
				setIsDeleteModalVisible(false);
				fetchAndSetUsers();
			} else {
				throw new Error("Unable to delete user.");
			}
		} catch (e: any) {
			message.error("Unable to delete user.");
			console.log(e.message);
		} finally {
			setDisableDeleteBtn(true);
			setIsDeleteLoading(false);
		}
	};

	const showDeleteModal = (user: string) => {
		setIsDeleteModalVisible(true);
		setUserSelectedForDeletion(user);
	};

	const handleDeleteModalOk = (userId: string) => {
		deleteUser(userId);
		setDeleteConfirmationInput("");
	};

	const handleDeleteModalCancel = () => {
		setIsDeleteModalVisible(false);
		setDeleteConfirmationInput("");
	};

	const handleOnChangeDeleteModalInput = (e) => {
		setDeleteConfirmationInput(e.target.value);
		if (e.target.value === "DELETE") setDisableDeleteBtn(false);
		else if (e.target.value !== "DELETE") setDisableDeleteBtn(true);
	};

	return (
		<div>
			<Button
				color="danger"
				icon={<DeleteOutlined />}
				shape="circle"
				onClick={() => showDeleteModal(userSelectedForDeletion)}></Button>
			<Modal
				mask={false}
				title="Delete User"
				open={isDeleteModalVisible}
				onOk={() => handleDeleteModalOk(userId)}
				onCancel={handleDeleteModalCancel}
				okType={"danger"}
				okText={"Delete"}
				okButtonProps={{
					disabled: disableDeleteBtn,
				}}>
				<Spin spinning={isDeleteLoading}>
					<Alert
						message={`WARNING: `}
						description={
							<div>
								You are about to delete{" "}
								<span className="bold-underline-text">
									{userSelectedForDeletion}
								</span>
								. Please type{" "}
								<span className="bold-underline-text">DELETE</span> in the text
								area below and press delete to confirm deletion of user.
							</div>
						}
						type="warning"
						showIcon
					/>
					<Input
						id="delete-input"
						onChange={handleOnChangeDeleteModalInput}
						value={deleteConfirmationInput}
					/>
				</Spin>
			</Modal>
		</div>
	);
};

export default DeleteUserModal;
